import ExposedFilters from './ExposedFilters';

export default ExposedFilters;
